import axios from "axios";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8001").replace(/\/+$/, "");
export const API = `${backendUrl}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  const token = localStorage.getItem("bexley_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e || typeof e !== "object") return String(e);
        const field = Array.isArray(e.loc) ? e.loc.filter((part) => part !== "body").join(".") : "";
        const msg = typeof e.msg === "string" ? e.msg : JSON.stringify(e);
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return JSON.stringify(detail);
}
